export default {
  default: {
    searchLabel: 'Search Address',
    selectedLocationLabel: 'Selected Locations',
    address: 'Address',
    comparablesLocationsLabel: 'Comparables Locations',
  },
}
